import script from "./MakeDisputeOfferModel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MakeDisputeOfferModel.vue?vue&type=script&lang=ts&setup=true"

import "./MakeDisputeOfferModel.vue?vue&type=style&index=0&id=3eb2d557&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb2d557"]])

export default __exports__